export const unityDownloadFile = () => {
  (window as { [key: string]: any })["download_file"] = (url: any) => {
    var download = document.getElementById("download") as HTMLAnchorElement;
    download!.href = url;
    download!.click();
  };
};
